import styled from 'styled-components';

const StyledCommunicationForwardWrapper = styled.div`
  padding-left: 20px;
  border-left: 4px solid ${({ theme }) => theme.colorPrimary};
`;

interface ICommunicationForwardContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {}

export const CommunicationForwardContainer = (
  props: ICommunicationForwardContainerProps,
) => {
  return <StyledCommunicationForwardWrapper {...props} />;
};
